import { useEffect } from "react";
import { useMutation } from "react-query";
import { deleteUserFormation } from "../../../apis/private.api";
import { ToggleableCardWrapper } from "../ToggleableCardWrapper";
import { useUser } from "../../../hooks/User";
import { IUserFormations } from "../../../constants/app.dto";
import { textChooser } from "../../../util/textChooser";
import { useIdToText } from "../../../hooks/IdToText";
import { InfoText } from "../../info_text";
import { InformationList } from "../experience/styled";

export interface CardFormationProps {
  career: string;
  type: string;
  college: string;
  careerId: string;
  userId: string;
}

export const CardFormation = (props: CardFormationProps) => {

  const { getDataByAttributeName, setDataByAttributeName, refreshUserSession } = useUser();
  const { converIdToText } = useIdToText();

  const formations = getDataByAttributeName("formationInfo");

  const { isSuccess, isError, isLoading, mutate } = useMutation((param: any) =>
    deleteUserFormation(param.uid, param.cid)
  );

  const handleDeleteFormation = (uid: string, cid: string) => {
    mutate({ uid, cid });
  }

  useEffect(() => {
    if (isSuccess) {
      const updatedFormations = formations.filter((f: IUserFormations) =>
        f.id !== props.careerId
      );
      setDataByAttributeName("formationInfo", updatedFormations);
    }
  }, [isSuccess]);

  return (
    <ToggleableCardWrapper
      handleDelete={() => handleDeleteFormation(props.userId, props.careerId)}
      isDeleting={isLoading}
    >
      <InformationList>
        <li>
          {textChooser('txt227')}:
          <span> {converIdToText(props.career, 'professions')}</span>
        </li>
        <li>
          {textChooser('txt114')}:
          <span> {converIdToText(props.type, 'grades')}</span>
        </li>
        <li>
          {textChooser('txt229')}:
          <span> {converIdToText(props.college, 'universities')}</span>
        </li>
      </InformationList>
      <InfoText text={textChooser("txt141")} type="danger" hidden={!isError} />
    </ToggleableCardWrapper>
  )
}